/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum CallingApplication {
    Debriefing = 0,
    Presentation = 1,
    LiveView = 2,
    Recording = 3,
}
